const pagesItemLedgerEn = {
  actionAdd: 'Add Item',
  actionCancel: 'Cancel',
  actionChangeStatus: 'Change Status',
  actionEdit: 'Edit',
  actionSave: 'Save',
  changeStatusDialogTitle: 'Change Status',
  changeStatusReasonPlaceholder: 'Reason (optional)',
  createDialogTitle: 'Add Item',
  detailPageTitle: 'Item Detail',
  editDialogTitle: 'Edit Item',
  fieldBaseUnit: 'Base Unit',
  fieldCreatedAt: 'Created At',
  fieldCurrency: 'Currency',
  fieldDescription: 'Description',
  fieldItemNumber: 'Item Number',
  fieldItemType: 'Item Type',
  fieldLeadTimeDays: 'Lead Time (days)',
  fieldMinOrderQty: 'Min Order Qty',
  fieldName: 'Name',
  fieldStandardPrice: 'Standard Price',
  fieldStatus: 'Status',
  fieldTargetStatus: 'Target Status',
  fieldUpdatedAt: 'Updated At',
  itemStatus: {
    ACTIVE: 'Active',
    ARCHIVED: 'Archived',
    BLOCKED: 'Blocked',
    DRAFT: 'Draft',
    OBSOLETE: 'Obsolete'
  },
  itemTypeOption: {
    FERT: 'Finished',
    FOOD: 'Food',
    HALB: 'Semi-finished',
    HAWA: 'Merchandise',
    ROH: 'Raw Material'
  },
  listFilterAll: 'All',
  listFilterPlaceholder: 'Search by item number or name...',
  listFilterType: 'Item Type',
  listPageTabAlert: 'Alert',
  listPageTabBom: 'Bom',
  listPageTabDealModeView: 'DealModeView',
  listPageTabItemList: 'ItemList',
  listPageTabOperationActivity: 'Operation & Activity',
  listPageTabOverview: 'Overview',
  listPageTabRulePolicy: 'Rule & Policy',
  listPageTabSetting: 'Setting',
  listPageTitle: 'Item',
  procurementNotSet: 'Procurement profile not configured',
  sectionIdentity: 'Identity',
  sectionProcurement: 'Procurement Profile'
};
export default pagesItemLedgerEn;